import classNames from 'classnames'
import { useEffect } from 'react'
import css from './styles.scss'

interface PostEmbedSocialMediaFields {
  channel: 'Facebook' | 'Giphy' | 'Instagram' | 'TikTok' | 'Twitter' | 'Youtube'
  postTitle?: string
  embedCode: string
}

interface EmbedSocialMediaProps {
  fields: PostEmbedSocialMediaFields
  id?: string
}

const EmbedSocialMedia: React.FC<EmbedSocialMediaProps> = ({
  fields,
  id,
}: EmbedSocialMediaProps) => {
  const { embedCode, channel } = fields

  // TODO: maybe don't use `id` here, this is the only embed that needs it so far
  // hash of the embed code or something? some kind of index?
  const containerId = `embed-container-${id || 'unknown'}`

  useEffect(() => {
    if (typeof window === 'undefined' || !window) return
    const container = document.getElementById(containerId)
    if (container) {
      container.innerHTML = embedCode

      const scripts = Array.from(container.querySelectorAll('script'))
      scripts.forEach((oldScript) => {
        const newScript = document.createElement('script')
        Array.from(oldScript.attributes).forEach((attr) =>
          newScript.setAttribute(attr.name, attr.value)
        )
        newScript.appendChild(document.createTextNode(oldScript.innerHTML))
        if (oldScript.parentNode) {
          oldScript.parentNode.replaceChild(newScript, oldScript)
        }
      })
    }
  }, [embedCode, containerId])

  if (typeof window === 'undefined' || !window) return <></>

  return (
    <div
      className={classNames(css.EmbedSocialMedia__container, {
        [css['EmbedSocialMedia__container--youtube']]: channel === 'Youtube',
        [css['EmbedSocialMedia__container--tiktok']]: channel === 'TikTok',
      })}
      id={containerId}
      key={containerId}
    />
  )
}

export default EmbedSocialMedia
